<template>
  <div class="app-inner">
    <el-form :inline="true" label-width="60px">
      <el-form-item label="镇">
        <el-input v-model="queryInfo.town" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="村">
        <el-input v-model="queryInfo.village" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="生产队">
        <el-input v-model="queryInfo.teamName" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="queryInfo.name" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="户主">
        <el-select
        v-model="queryInfo.houseHolderName"
        filterable
        clearable
        :remote-method="remoteMethod"
        remote>
          <el-option
          v-for="item in peopleList"
          :key="item.id"
          :label="item.farmerName"
          :value="item.farmerNo"
          />
        </el-select>
        <!-- <el-input v-model="queryInfo.houseHolderName" clearable placeholder="请输入"/> -->
      </el-form-item>
      <el-form-item label="身份证">
        <el-input v-model="queryInfo.idCardNo" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    indexKey="编码"
    >
      <template #index/>
      <template #action={row}>
        <el-button type="text" size="small" @click="getDetails(row)">继承明细</el-button>
      </template>
    </table-list>
    <el-dialog
    title="继承明细"
    :visible.sync="showDetailed"
    :before-close="close"
    center
    destroy-on-close>
      <el-table
      :data="detailedList"
      >
      <!-- :summary-method="getSummaries"
      show-summary -->
      <el-table-column
        v-for="item in detailedColumnDefs"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        />
      <!-- :columnDefs="detailedColumnDefs"
      :showPagination="false" -->
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import { summaryListByPage, euFarmerAgeGetDetail, farmerExport, euFarmerInfoQuery } from '@/api/community.js'
export default {
  data () {
    return {
      queryInfo: {
        town: '',
        village: '',
        teamName: '',
        name: '',
        houseHolderName: '',
        idCardNo: ''
      },
      page: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      loading: false,
      columnDefs: [
        // { label: '编码', prop: 'bm' },
        { label: '人员编号', prop: 'farmerSortNo' },
        { label: '姓名', prop: 'farmerName' },
        { label: '户主', prop: 'houseHolderName' },
        { label: '与户主关系', prop: 'houseHolderRelation' },
        { label: '镇', prop: 'town' },
        { label: '村', prop: 'village' },
        { label: '生产队', prop: 'teamName' },
        { 
          label: '性别',
          formatter: (row) => {
            return row.gender ? row.gender === 1 ? '男' : '女' : ''
          }
        },
        { label: '民族', prop: 'national' },
        { label: '身份证号', prop: 'idCardNo' },
        { label: '出生年月', prop: 'birthday' },
        { label: '人员性质', prop: 'peopleNature' },
        { label: '联系电话', prop: 'phone' },
        { label: '现居住地址', prop: 'livePlace' },
        { label: '户籍地址', prop: 'registrationAddress' },
        { label: '户主联系电话', prop: 'houseHolderPhone' },
        { label: '原农龄', prop: 'originAge' },
        {
          label: '婚嫁等因素',
          child: [
            { label: '调增', prop: 'marriageAdd' },
            { label: '调减', prop: 'marriageMinus' },
          ]
        },
        { label: '按规定调减农龄', prop: 'regulationsAdjust' },
        { label: '核定农龄', prop: 'checkedAge' },
        { label: '继承农龄',
          child: [
            { label: '调增', prop: 'inheritAdd' },
            { label: '调减', prop: 'inheritMinus' },
          ]
        },
        { label: '调入调出/赎回', prop: 'adjust' },
        { label: '合计农龄', prop: 'totalAge' },
        { label: '操作', prop: 'action' }
      ],
      detailedList: [],
      detailedColumnDefs: [
        { label: '被继承人', prop: 'inheritedFarmerName' },
        { label: '继承人', prop: 'farmerName' },
        { label: '份额', prop: 'age' },
        { label: '创建时间', prop: 'createTime' },
        { label: '备注', prop: 'remark' },
      ],
      showDetailed: false,
      peopleList: [],
      timer: null
    }
  },
  components: {
    TableList,
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getDetails (row) {
      this.showDetailed = true
      if (!row.ageApplyNo) return
      euFarmerAgeGetDetail({
        eventId: row.ageApplyNo
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.detailedList = result.farmerAgeHeritageEntityList || []
        }
      })
    },
    exportData () {
      farmerExport({
        ...this.queryInfo,
      }).then(res => {
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const elink = document.createElement("a");
        elink.download = '成员汇总信息.xls';
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      })
    },
    close () {
      this.showDetailed = false
      this.detailedList = []
    },
    getData () {
      summaryListByPage({
        ...this.queryInfo,
        pageSize: this.pageSize,
        pageNum: this.page,
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
     getPeopleList (value) {
      euFarmerInfoQuery({
        pageNum: 1,
        pageSize: 100,
        name: value
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.peopleList = result.records
      })
    },
    remoteMethod (value) {
      clearTimeout(this.timer)
      if (value) {
        this.timer = setTimeout(() => {
          this.getPeopleList(value)
        }, 500)
      } else {
        this.peopleList = []
      }
    }
    // getSummaries(param) {
    //   const { columns, data } = param;
    //   const sums = [];
    //   columns.forEach((column, index) => {
    //     if (index === 0) {
    //       sums[index] = '合计';
    //       return;
    //     }
    //   })
    // }
  },
  mounted () {
    this.query()
    // this.getPeopleList()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 950px;
  width: 60%;
}
</style>